import { forwardRef } from "react";
import type { IconProps } from "../shared";
import { Icon } from "../icon";
export const IconMinus = forwardRef<HTMLElement, IconProps>((props, ref) => (
    <Icon ref={ref} {...props}>
        <path fill="#111928" d="M5 11h14v2H5z" />
    </Icon>
));
IconMinus.displayName = "IconMinus";
